<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>


    <!--  hero banner   -->
    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="https://img.jakpost.net/c/2017/11/17/2017_11_17_36085_1510900861._large.jpg">
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">Aeroviewer Social media teams</h1>
            </div>
        </div>
    </section>
    <!--  End of hero banner   -->


    <section class="bg-master-lightest p-b-60 p-t-60">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <h5 class="block-title hint-text no-margin">For all the social media professionals</h5>
                <div class="row">
                    <div class="col">
                        <p class="h1 m-t-5">AEROVIEWER is a valuable solution as it can provide instantly shareable
                            videos
                            and photos.</p>

                        <p>Shareable videos can be created at a fraction of the time needed so far for the same
                            operation, by selecting and combining video segments to be auto-edited and shared to any
                            Facebook or other social media page. <br><br> The speed of the content preparation, the
                            quality of the visual content, the variety of the available photos and videos, the “Tailored
                            by You” functionality and the price to enjoy all these are the unsurpassed advantages of the
                            AEROVIEWER platform.</p>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <div class="p-l-35 md-p-l-5">
                            <img class="image-responsive-height" src="/static/web/assets/images/social-03.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <avr-footer></avr-footer>

    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

        app.on('mount', () => {
            $('#videoTourModal').on('hidden.bs.modal', function (e) {
                let youtube = $('#youtube');
                youtube.attr('src', '');
                youtube.attr('src', 'https://www.youtube.com/embed/oTmQCSsHz-s?rel=0');
            });
        })

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/social/app.tag.html